import React, { FC, ReactNode } from 'react';
import { Button, Modal, Pill } from '@clearcover/atlas';
import { reportEvent } from 'Shared/analytics';

import { AccordionItem } from 'QuoteApp/components/Accordion';

import styles from './styles.module.css';

export type StepItemModal = {
  buttonText: string;
  headerText: string;
  bodyContent: ReactNode;
};

export const StepItem: FC<{
  name: string;
  stepNumber: number;
  heading: string;
  content?: null | string;
  modal?: StepItemModal;
  startOpen?: boolean;
  tag?: React.JSX.Element | string | null;
}> = ({ name, stepNumber, heading, content, modal, startOpen, tag }) => {
  return (
    <AccordionItem
      className={styles.stepsAccordionItem}
      cssOverrides={{
        listItem: styles.stepsAccordionListItem,
        collapsibleContent: styles.collapsibleContent,
        headerContainer: styles.headerContainer,
      }}
      data-testid={`congrats-list-item-${name}`}
      key={`congrats-list-item-${name}`}
      identifier={name}
      startOpen={startOpen}
      onToggleClick={() => {
        reportEvent(`CongratsAgent:Accordion:${name}`);
      }}
      header={
        <div className={styles.stepHeading}>
          <div className={styles.stepNumber}>{stepNumber}</div>
          {heading}
          {tag && (
            <Pill variant="neutral" className={styles.tagPill}>
              {tag}
            </Pill>
          )}
        </div>
      }
    >
      {content && (
        <div
          className={styles.congratsContent}
          data-testid={`congrats-content-${name}`}
        >
          <div
            className={styles.congratsContentDisclosure}
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
          {modal && (
            <Modal
              toggle={(openModal) => (
                <Button
                  link
                  onClick={openModal}
                  className={styles.modalButton}
                  size="sm"
                  data-testid={`congrats-modal-button-${name}`}
                >
                  {modal?.buttonText}
                </Button>
              )}
            >
              {(close) => (
                <div
                  className={styles.modalContainer}
                  data-testid={`congrats-modal-container-${name}`}
                >
                  <h1 className={styles.modalHeading}>{modal?.headerText}</h1>
                  <div className={styles.modalBody}>{modal?.bodyContent}</div>
                  <div className={styles.modalFooterContainer}>
                    <Button
                      onClick={close}
                      variant="primary"
                      size="md"
                      data-testid={`congrats-modal-back-${name}`}
                    >
                      Got It
                    </Button>
                  </div>
                </div>
              )}
            </Modal>
          )}
        </div>
      )}
    </AccordionItem>
  );
};
